import React, { useCallback } from 'react';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { getPotDisplayName } from 'features/pots/utils';
import Links from 'utils/links';
const BankWithdrawInfoCard = ({ potName, noticeDays }) => {
    const handlePress = useCallback(() => {
        Links.openKnownLink('withdrawalInfo');
    }, []);
    return (<ProgressCard lightBg isActiveStep noTextDecoration completed={false} title={`Withdrawing from ${getPotDisplayName(potName)}`}>
      <Text Secondary TextThin-14>
        {noticeDays
            ? `Because this is a notice pot, your funds will be released after ${noticeDays} days. `
            : 'We expect them to arrive in 1 working day. '}
        <Text Primary Text-14 suppressHighlighting onPress={handlePress}>
          Learn more
        </Text>
      </Text>
    </ProgressCard>);
};
export default BankWithdrawInfoCard;
